

<header class="modal-header bg-white border-bottom-0">
  <h5 class="modal-title" id="modal-basic-title font-weight-bold">
    {{ modalGenerico.titulo }}
  </h5>
  <button type="button" class="close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body">
  <section *ngIf="!onlyPassword">
    <h6 class="col-12 m-auto pb-1 form font-weight-bold">Datos del usuario</h6>
    <form class="col-12 m-auto form" [formGroup]="formDatosBasicos" (ngSubmit)="actualizarDatos()">
      <div class="form-row mb-2" *ngIf="tipo_prestador === authService.getTipoUser();" >
        <div class="col-sm-12 col-md-4 form-group m-auto">
          <label class="small text-secondary" for="telefono_reportado_1">Teléfono uno reportado por
            {{authService.getRolDetalleUser() === tipo_prestador_no_comerciante ? 'DIAN' : 'RUES'}}</label>
          <input id="telefono_reportado_1" formControlName="telefono_reportado_1" class="form-control" type="email">
          <div id="mensaje"
            *ngIf="!formDatosBasicos.controls.telefono_reportado_1.valid  && (formDatosBasicos.get('telefono_reportado_1'))">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Solo se permiten valores
              numéricos</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 form-group m-auto">
          <label class="small text-secondary" for="telefono_reportado_2">Teléfono dos reportado por
            {{authService.getRolDetalleUser() === tipo_prestador_no_comerciante ? 'DIAN' : 'RUES'}}</label>
          <input id="telefono_reportado_2" formControlName="telefono_reportado_2" class="form-control" type="email">
          <div id="mensaje"
            *ngIf="!formDatosBasicos.controls.telefono_reportado_2.valid  && (formDatosBasicos.get('telefono_reportado_2'))">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Solo se permiten valores
              numéricos</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 form-group m-auto">
          <label class="small text-secondary" for="patrimonio_neto">Patrimonio Neto</label>
          <input id="patrimonio_neto" formControlName="patrimonio_neto" class="form-control" type="text">
          <div id="mensaje"
            *ngIf="!formDatosBasicos.controls.patrimonio_neto.valid  && (formDatosBasicos.get('patrimonio_neto'))">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Solo se permiten valores
              numéricos y máximo 15 dígitos</p>
          </div>
        </div>
      </div>
      <div class="form-row mb-2">
        <div class="col-sm-12 col-md-4 form-group">
          <label class="small text-secondary" for="correo">Correo eletrónico</label>
          <input id="correo" formControlName="correo_electronico" class="form-control" type="text">
          <div id="mensaje"
            *ngIf="!formDatosBasicos.controls.correo_electronico.valid  && (formDatosBasicos.get('correo_electronico'))">
            <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Dígite
              un correo válido</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 form-group">
          <label class="small text-secondary" for="es_caja_compensacion">¿Es caja de compensación?</label>
          <div>
            <label for="es_caja_compensacion">No</label>
            <div class="custom-control custom-switch d-inline ml-2">
              <input type="checkbox" class="custom-control-input" id="es_caja_compensacion" formControlName="es_caja_compensacion">
              <label class="custom-control-label" for="es_caja_compensacion">Si</label>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 form-group" *ngIf="formDatosBasicos.get('es_caja_compensacion').value">
          <label class="small text-secondary" for="numero_certificado">Número del certificado</label>
          <input id="numero_certificado" formControlName="numero_certificado" class="form-control" type="text">
        </div>
      </div>
      <div class="form-row mb-2">
        <div class="col form-group d-flex justify-content-center">
          <button type="submit" [disabled]="!formDatosBasicos.valid" class="btn btn-primary text-white btn-width">Actualizar datos</button>
        </div>
      </div>
    </form>
  </section>
  <section>
    <h6 class="col-12 m-auto pb-1 form font-weight-bold">Cambio de contraseña</h6>
    <form class="col-12 m-auto form" [formGroup]="formCambiarContrasena" (ngSubmit)="cambiarContrasena()">
      <div class="form-row mb-2">
        <div class="col-md-4 form-group m-auto">
          <label class="small text-secondary" for="contresena">Contraseña actual</label>
          <input id="contresena" formControlName="clave_acceso_anterior" class="form-control" type="password">
        </div>
        <div class="col form-row" formGroupName="contrasenaGroup">
          <div class="col form-group m-auto">
            <label class="small text-secondary" for="nueva_contrasena">Nueva contraseña</label>
            <input id="nueva_contrasena" formControlName="clave_acceso" class="form-control" type="password"
              ngbTooltip="Usa al menos 8 caracteres, un carácter especial (%$+!.), una mayúscula y un número.">
            <div id="mensaje"
              *ngIf="!formCambiarContrasena.get('contrasenaGroup').get('clave_acceso').valid && (formCambiarContrasena.get('contrasenaGroup').get('clave_acceso').dirty)">
              <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Contraseña debil</p>
            </div>
          </div>
          <div class="col form-group m-auto">
            <label class="small text-secondary" for="nueva_contrasena_confirmacion">Confirmar nueva contraseña</label>
            <input id="nueva_contrasena_confirmacion" formControlName="clave_acceso_confirmacion" class="form-control"
              type="password">
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4"></div>      
        <div id="validacion_igual"
              class="col m-3"
              *ngIf="formCambiarContrasena.get('contrasenaGroup').get('clave_acceso').value != '' && formCambiarContrasena.get('contrasenaGroup').get('clave_acceso_confirmacion').value != ''">
              <div *ngIf="formCambiarContrasena.get('contrasenaGroup').get('clave_acceso').value != formCambiarContrasena.get('contrasenaGroup').get('clave_acceso_confirmacion').value">
                <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Las contraseñas ingresadas no coinciden.</p>
              </div>
        </div>
      </div>
      <div class="form-row mb-2">
        <div class="col form-group d-flex justify-content-center">
          <button type="submit" [disabled]="!formCambiarContrasena.valid"
            class="btn btn-primary text-white btn-width mt-2">Cambiar
            contraseña</button>
        </div>
      </div>
    </form>
  </section>
</section>